import { Modal, Button } from 'react-bootstrap'
import api from '../../../config/AxiosInstance'
import * as Common from '../../../utils/Common'

function ModalConfirmPackaging({ detail, uom, onHide, refreshData, ...props }) {
  const handleSet = async () => {
    try {
      const res = await api.post(`/master/items/${detail.id}/pack`, {
        uom_id: uom.uom_id,
        is_pack: true
      })
      Common.showPopUpSuccessMessage(res.data.message)
      onHide()
      refreshData()
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }

  return (
    <Modal {...props} centered onHide={onHide} size="md">
      <Modal.Header closeButton className="border-0 bg-light">
        <Modal.Title
          style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#6c757d' }}
        >
          Set Kemasan
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-4">
        <p className="mb-0 text-center" style={{ fontSize: '1rem' }}>
          set &lsquo;<strong>{uom?.uom_name}</strong>&rsquo; as kemasan?
        </p>
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0">
        <Button
          variant="link"
          onClick={onHide}
          className="text-secondary text-decoration-none fw-bold"
        >
          Cancel
        </Button>
        <Button
          variant="warning"
          onClick={handleSet}
          className="text-white fw-bold px-4"
        >
          Set
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalConfirmPackaging
